
<template>
  <div>
    <div
      class="summary"
      :style="[!hasRead ? { 'background-color': '#c7f29540' } : '']"
      @click="$emit('selected', index)"
    >
      <img class="image" :src="message.ImageUrl" @error="imageUrlAlt" />
      <div class="texts">
        <div class="text">
          <b>{{ message.Title }}</b>
        </div>
        <div class="text">{{ message.Body }}</div>
        <div class="sendDate">{{ sendDate }}</div>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>



export default {
  props: ["message", "index"],
 
  computed: {
    sendDate() {
      return this.toJalaliDateTime(this.message.SentDate);
    },
    hasRead() {
      return this.message.readDate != "";
    },
    hasImage() {
      return this.message.ImageUrl != "";
    },
  },

  methods: {
    imageUrlAlt(event) {
      event.target.src = require("../../assets/blank_transparent.png");
    },
    
  },
  
};
</script>
<style scoped>
.image {
  width: 80px;
  height: 80px;
  background-size: 100%;
  float: right;
}
.sendDate {
  float: left;
  direction: ltr;
}
.texts {
  float: right;
  width: 100%;
  display: grid;
}
.summary {
  display: flex;
  padding: 20px 20px 0px 20px;
  cursor: pointer;
}
.text {
  margin: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

